/* eslint-disable no-console */
import { handleRequest } from './base';
import TransactionFilter from '../filters/transaction';
import CustomFirebase from '../helpers/custom-firebase';
import money from '../helpers/money';

const walletQuery = () => {
  const query = new URLSearchParams(window.location.search);
  const wallet = query.get('wallet') || 0;
  return {
    wallet,
  };
};

const TransactionRepo = {
  getToken: (business) => handleRequest({
    method: 'get',
    url: `/business/${business.id}/token`,
  }),

  createNew: (business, account, { id, amount, currency, name, destination_uri, desc, value_ts, batchID, signature, loc }) => {
    const endpoint = `/business/${business.id}/accounts/${account.id}/transfers/${id}`;
    const body = {
      amount: money.toInt(amount, currency, false),
      currency,
      destination_name: name,
      destination_uri,
      description: desc,
      batch_id: batchID || null,
      value_ts,
      signature,
      loc,
    };

    return handleRequest({
      method: 'put',
      url: endpoint,
      data: body,
    }, false);
  },

  confirm2fa: (business, account, { txid, code }) => {
    const endpoint = `/business/${business.id}/accounts/${account.id}/transfers/${txid}`;
    const body = {
      txid,
      code,
    };

    return handleRequest({
      method: 'post',
      url: endpoint,
      data: body,
    }, false);
  },

  createTransfer: (business, account, { amount, currency, uri, token, destination_name = 'Destination name' }) => {
    const endpoint = `/business/${business.id}/accounts/${account.id}/transfers/bank-transfer`;
    const body = {
      token,
      amount,
      currency,
      destination_name,
      destination_uri: uri,
    };

    return handleRequest({
      method: 'post',
      url: endpoint,
      data: body,
    });
  },

  fetchCollection: (filters = new TransactionFilter()) => {
    const endpoint = `/business/${filters.account().business_id}/accounts/${filters.account().id}/transfers`;
    const query = filters.filters();
    const wallet = walletQuery();
    const params = { ...wallet, ...query };

    return handleRequest({
      method: 'get',
      url: endpoint,
      params,
    });
  },

  listenForTransactionsByBatch: (account, batch, callback) => {
    const db = CustomFirebase.connection();
    const transactionsRef = db.collection('accounts').doc(account.id).collection('transfers');
    const query = transactionsRef.where('batch_id', '==', batch.id).orderBy('created_at', 'asc');

    return query.onSnapshot(
      (docSnapshot) => {
        callback(docSnapshot);
      },
      (err) => {
        console.log(`Error listening for transactions: ${err}`);
      },
    );
  },

  fetchCollectionByBatch: (account, batch) => {
    const db = CustomFirebase.connection();
    const transactionsRef = db.collection('accounts').doc(account.id).collection('transfers');
    const query = transactionsRef.where('batch_id', '==', batch.id).orderBy('created_at', 'asc');

    return query.get();
  },
};

export { TransactionRepo };
